// Main entry point
import { initLineWrapDetector } from './modules/links-wrap.js';
import { initSlideshow } from './modules/slideshow.js';
// import { initErrorNotices } from './modules/error-notices.js';

// Initialize all modules when DOM is ready
function initializeApp() {
    initLineWrapDetector();
    initSlideshow();
//    initErrorNotices();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeApp);
} else {
    initializeApp();
}
